import { RecruitPositionDetailPage } from "@/pages/recruitPositionDetail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/recruit-positions/$recruitPositionId/",
)({
	component: RouteComponent,
});

function RouteComponent() {
	return <RecruitPositionDetailPage />;
}
